import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { saasAuth } from '../../lib/api';

const nav = [
  { to: '/admin', label: 'Dashboard', icon: 'dashboard', end: true },
  { to: '/admin/tenants', label: 'Tenants', icon: 'domain' },
  { to: '/admin/modelos', label: 'Modelos', icon: 'inventory_2' },
  { to: '/admin/planos', label: 'Planos', icon: 'sell' },
  { to: '/admin/pagamentos', label: 'Pagamentos', icon: 'payments' },
];

export default function AdminLayout() {
  const navigate = useNavigate();

  function logout() {
    saasAuth.clear();
    navigate('/admin/login');
  }

  return (
    <div className="bg-background min-h-screen">
      <aside className="fixed left-0 top-0 h-full w-72 bg-surface-container-low z-50 flex flex-col shadow-[1px_0_8px_rgba(0,0,0,0.02)]">
        <div className="p-6 flex items-center gap-3 mb-4">
          <div className="w-10 h-10 bg-primary-container rounded-lg flex items-center justify-center text-on-primary-container shadow-sm">
            <span className="material-symbols-outlined">admin_panel_settings</span>
          </div>
          <div>
            <div className="font-h3 text-h3 text-on-surface tracking-tight">EtiquetandoApp</div>
            <div className="text-[10px] text-on-surface-variant uppercase">Admin SaaS</div>
          </div>
        </div>
        <nav className="flex-1 px-4 space-y-1">
          {nav.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) =>
                `flex items-center px-4 py-3 rounded-xl transition-all ${
                  isActive
                    ? 'bg-primary-container text-on-primary-container font-bold shadow-sm'
                    : 'text-on-surface-variant hover:bg-surface-container-high hover:text-on-surface'
                }`
              }
            >
              <span className="material-symbols-outlined mr-3">{item.icon}</span>
              {item.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-6 mt-auto border-t border-surface-variant">
          <button
            onClick={logout}
            className="w-full flex items-center gap-3 px-4 py-3 rounded-xl text-on-surface-variant hover:bg-error-container/30 hover:text-error transition-colors"
          >
            <span className="material-symbols-outlined text-[14px]">logout</span>
            Sair do painel
          </button>
        </div>
      </aside>
      <main className="pl-72">
        <div className="flex flex-col w-full h-full max-w-container-max mx-auto px-8 py-12 gap-section-gap">
          <Outlet />
        </div>
      </main>
    </div>
  );
}

